<script setup lang="ts">
import { computed } from 'vue';
import BaseIcon from '@/components/base/BaseIcon.vue';
import { PersonBasicDataProviderError } from '@/types/enums';
import { formatTaxId } from '@/utils/formatters';

const props = defineProps<{
  error: PersonBasicDataProviderError;
  taxId: string | null;
}>();

const isMinor = computed(() => props.error === PersonBasicDataProviderError.MINOR);
const taxIdLabel = computed(() => (props.taxId ? formatTaxId(props.taxId) : 'informado'));
</script>

<template>
  <div class="bg-white rounded-2xl shadow-sm border border-gray-200 py-14 px-8 text-center max-w-2xl mx-auto">
    <div class="w-20 h-20 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
      <BaseIcon size="xl" class="text-gray-500">{{ isMinor ? 'child_care' : 'error' }}</BaseIcon>
    </div>

    <template v-if="isMinor">
      <h2 class="text-2xl font-semibold text-gray-800 mb-4">Dados indisponíveis para menores de idade</h2>
      <p class="text-gray-600 leading-relaxed">
        O CPF {{ taxIdLabel }} pertence a uma pessoa menor de idade e, por isso, seus dados não podem ser exibidos.
      </p>
    </template>

    <template v-else>
      <h2 class="text-2xl font-semibold text-gray-800 mb-4">Não foi possível consultar este CPF</h2>
      <p class="text-gray-600 leading-relaxed">
        A consulta do CPF {{ taxIdLabel }} retornou um erro e os dados desta pessoa não podem ser exibidos.
      </p>
    </template>
  </div>
</template>
